import { GAME_BADGES } from '../constants';
import { GameBadgesConfig, GameCategories } from '../types';

/** Собирает список бейджей с учетом их приоритета */
export const getGameBadges = (gameCategories: GameCategories) => {
  for (const badgeConfig of GAME_BADGES) {
    const badges = selectBadgesFrom(gameCategories, badgeConfig);
    if (badges.length) return badges;
  }
  return [];
};

/** Проходит по списку категорий данной игры и собирает массив компонентов-бейджей */

function selectBadgesFrom(gameCategories: GameCategories, badgesConfig: GameBadgesConfig) {
  return gameCategories.flatMap((category) => {
    const badgeConfig = badgesConfig[category.id];
    return badgeConfig && badgeConfig.getCondition(gameCategories) ? [badgeConfig.component] : [];
  });
}
